import Vue from 'vue';
import { init as initSharedErrorTracking, isEnabled, resetForTests, setTag } from '@pleased-npm/error-tracking';
import { resetChatbotContextForTests } from './context';
import type { InitErrorTrackingOptions } from './types';

declare const GLOBAL_GLITCHTIP_DSN: string;
declare const GLOBAL_BUILD_PROFILE: string;
declare const GLOBAL_APP_VERSION: string;

const APP_NAME = 'chatbot-web';

const getEnvironment = (): 'stage' | 'prod' => {
  return String(GLOBAL_BUILD_PROFILE || '').includes('prod') ? 'prod' : 'stage';
};

const getDsn = (): string => {
  if (typeof GLOBAL_GLITCHTIP_DSN === 'string' && GLOBAL_GLITCHTIP_DSN.trim()) {
    return GLOBAL_GLITCHTIP_DSN.trim();
  }
  return '';
};

/**
 * Init GlitchTip (Sentry-compatible). No-op when DSN is empty (local/dev without secrets).
 * `overrides` is for tests / controlled smoke verification only.
 */
export const initErrorTracking = (overrides?: InitErrorTrackingOptions): void => {
  const dsn = overrides?.dsn ?? getDsn();
  const environment = overrides?.environment ?? getEnvironment();
  const release = overrides?.release ?? (GLOBAL_APP_VERSION || 'unknown');

  initSharedErrorTracking({
    app: APP_NAME,
    dsn,
    environment,
    release,
    Vue,
  });
  setTag('build_profile', GLOBAL_BUILD_PROFILE || 'unknown');
};

/** Reset init flag and chatbot context — tests only. */
export const resetErrorTrackingForTests = (): void => {
  resetChatbotContextForTests();
  resetForTests();
};

export const isErrorTrackingEnabled = (): boolean => isEnabled();
